import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import Autosuggest from "react-autosuggest";
import { Link } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { getSearchPlans } from "../../actions/plans";
import useDebounce from "../../hooks/useDebounce";
import styles from "./styles";

export const FullSearch = () => {
  const classes = styles();
  const dispatch = useDispatch();
  const [value, setValue] = useState<any>("");
  const [isLoading, setIsLoading] = useState(false);
  const { plans } = useSelector(state => state.searchPlans);
  const debouncedSearchTerm = useDebounce(value, 600);
  let history = useHistory();

  useEffect(() => {
    handleSearchPlans();
  }, [debouncedSearchTerm]);
  const handleSearchPlans = async () => {
    if (debouncedSearchTerm || debouncedSearchTerm === "") {
      setIsLoading(true);
      await dispatch(getSearchPlans(debouncedSearchTerm.value));
      setIsLoading(false);
    }
  };
  const getSuggestionValue = suggestion => {
    console.log(
      "🚀 ~ file: index.tsx ~ line 26 ~ FullSearch ~ suggestion",
      suggestion
    );
    history.push(`/como-usar-tu-plan/planes/${suggestion.id}`);
    // return suggestion.name;
  };
  const renderSuggestion = suggestion => {
    return <div>{suggestion.name}</div>;
  };

  const onChange = (event, { newValue }) => {
    setValue({
      value: newValue
    });
    setInputProps({ ...inputProps, value: newValue });
  };
  const [inputProps, setInputProps] = useState({
    placeholder: "Buscar plan ideal 4-4D, coberturas, reembolsos",
    value: value,
    onChange: onChange
  });
  const onSuggestionsClearRequested = () => {};
  return (
    <div className={classes.mainContainer}>
      <div className={classes.containerSearch}>
        <div style={{ width: "100%" }}>
          <Autosuggest
            suggestions={plans}
            getSuggestionValue={getSuggestionValue}
            onSuggestionsFetchRequested={() => console}
            onSuggestionsClearRequested={onSuggestionsClearRequested}
            renderSuggestion={renderSuggestion}
            inputProps={inputProps}
            theme={classes}
          />
        </div>
        <Link href="#" className={classes.linkStyle}>
          ¿Cómo buscar mi plan?
        </Link>
      </div>
    </div>
  );
};
